// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1___951716d2aab0ee110dc","cls2":"mentions_milestone_ping-cls2__d852d43f4040f1493672 mentions_milestone_ping-cls1___951716d2aab0ee110dc"};